export default "__VITE_ASSET__CX1NCMdo__"